export default __webpack_public_path__ + "static/media/65_desktop.60c0eaef.jpg";